import React from 'react'

export const ContainerSubTitleGrey = (props) => {
  return (
    <div className="container-list-this">
    <h1 className="title-message" style={props.style}>{props.text}</h1>
  </div>
  )
}
